package com.schoolconnect.app.feature.parents

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.foundation.layout.RowScope
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.feature.common.shellRoleLabel
import com.schoolconnect.app.feature.common.shellRoleSubtitle

@Composable
fun ParentsScreen(
    state: ParentsUiState,
    onEvent: (ParentsUiEvent) -> Unit,
    shellRoleCode: String = "",
    shellSchoolLabel: String = "iConnect.School",
    onChangeRole: () -> Unit = {},
    onLogout: () -> Unit = {},
    headerActions: @Composable RowScope.() -> Unit = {
        var expanded by remember { mutableStateOf(false) }
        ShellTopRightActions(
            roleLabel = shellRoleLabel(shellRoleCode),
            roleSubtitle = shellRoleSubtitle(shellRoleCode),
            initials = shellAvatarInitials(shellRoleLabel(shellRoleCode)),
            expanded = expanded,
            onExpandedChange = { expanded = it },
            onChangeRole = onChangeRole,
            onLogout = onLogout
        )
    }
) {
    ParentsScreenContent(
        state = state,
        onEvent = onEvent,
        headerActions = headerActions
    )
}
